import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { subDays } from 'date-fns';
import {
    setFilterDate,
    setFilterCompare,
    setFilterDateCompare,
} from 'src/context/reducers/filter-settings/filterSlice';

export default function VisibilityLayout() {
    const dispatch = useDispatch();

    useEffect(() => {
        const now = new Date();
        dispatch(
            setFilterDate({
                start: subDays(now, 30).toISOString(),
                end: subDays(now, 1).toISOString(),
            })
        );
        dispatch(setFilterCompare(false));
        dispatch(
            setFilterDateCompare({
                compareStart: subDays(now, 60).toISOString(),
                compareEnd: subDays(now, 31).toISOString(),
            })
        );
    }, [dispatch]);

    return <Outlet />;
}
